import { dew as _signDew } from "../math/sign";
var exports = {},
    _dewExec = false;
export function dew() {
  if (_dewExec) return exports;
  _dewExec = true;

  var sign = _signDew(),
      abs = Math.abs,
      floor = Math.floor;

  exports = function (value) {
    if (isNaN(value)) return 0;
    value = Number(value);
    if (value === 0 || !isFinite(value)) return value;
    return sign(value) * floor(abs(value));
  };

  return exports;
}